import React, { useEffect, useState, useRef } from "react";
import { Modal, Button, Row, Col, Form, InputGroup } from "react-bootstrap";
import { InputOtp } from "primereact/inputotp";
import usePostRequest from "../../hooks/usePostRequest";
import { NavLink, useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../../constant/_constant";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "./Otpverification.css";
import { saveUser } from "../../redux/authReducer";
import { usePostHog } from "@posthog/react";
import * as Sentry from "@sentry/react";

function OtpVerfication({ show, onClose, formData }) {
  const [timer, setTimer] = useState(60);
  const [token, setTokens] = useState("");
  const dispatch = useDispatch();
  const posthog = usePostHog();

  const [showResend, setShowResend] = useState(false);
  const { isLoading, postData: otpVerification } = usePostRequest(
    API_ENDPOINTS.OTP_VERIFICATION,
  );
  const { isLoading: loginLoading, postData: login } = usePostRequest(
    API_ENDPOINTS.LOGIN,
  );
  const { isLoading: permissionLoading, postData: fetchPermission } =
    usePostRequest(API_ENDPOINTS.GET_USER_DETAILS);

  const onSuccessPermission = (response) => {
    dispatch(saveUser(response));

    if (response?.user?.roles) {
      const roleNames = response.user.roles.map((role) => role.toLowerCase());
      if (roleNames.includes("super-admin")) {
        navigate("/list-order-lifecycle");
      } else if (roleNames.includes("sales")) {
        navigate("/list-opportunities");
      } else {
        navigate("/list-order-lifecycle");
      }
    }
  };

  const navigate = useNavigate();

  const onSuccess = (response) => {
    toast.success("Logged in successfully.");
    localStorage.setItem("token", response?.access_token);

    
    const user = response?.user;
    if (user) {
      posthog.identify(user?.id, {
        email: user?.email,
        name: `${user?.first_name} ${user?.last_name}`,
        username: user?.username,
      });
      Sentry.setUser({
        id: user?.id,
        email: user?.email,
        username: user?.username,
      });
    }
    posthog.capture("user_logged_in", {
      username: response?.user?.username,
      email: response?.user?.email,
      roles: response?.user?.roles,
    });

    fetchPermission({}, onSuccessPermission);
  };

  const modalRef = useRef(null);
  const onError = (error) => {
    if (error) {
      toast.error(error?.message);
      setTokens("");
    }
  };

  const onSuccessResend = () => {
    toast.info("Resent OTP");
    setTimer(60);
    setShowResend(false);
  };
  const onErrorResend = (error) => {
    toast.error(error?.errors?.message);
  };

  const handleVerify = async () => {
    const payload = {
      username: formData?.username,
      otp: token,
    };
    otpVerification(payload, onSuccess, onError);
  };

  const handleResend = () => {
    login(formData, onSuccessResend, onErrorResend);
  };

  useEffect(() => {
    let countdown;
    if (show && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(countdown);
            setShowResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(countdown);
  }, [show, timer]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Debugging: Log key press
      console.log("Key pressed:", event.key);
      if (event.key === "Enter" && show && token.length === 6 && !isLoading) {
        console.log("Enter key triggered verification");
        handleVerify();
      }
    };

    if (show) {
      console.log("Adding keydown listener");
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      console.log("Removing keydown listener");
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [show, token, isLoading]);

  // Focus modal when it opens
  useEffect(() => {
    if (show && modalRef.current) {
      modalRef.current.focus();
    }
  }, [show]);

  return (
    <>
      <Modal
        show={show}
        // onHide={onClose}
        centered
        className="otp-modal-container"
      >
        <Modal.Header></Modal.Header>
        <Modal.Body className="pb-0">
          <div className="text-center">
            <h5 className="modal-title">Verify Your Identity</h5>
            <p className="modal-subtitle">
              Enter the 6-digit code sent to your email.
            </p>
          </div>
          <div className="otp-input-wrapper">
            <InputOtp
              value={token}
              onChange={(e) => setTokens(e.value)}
              length={6}
              integerOnly
            />
          </div>
          <div className="resend-timer-wrapper modal-subtitle">
            {timer > 0 ? (
              <p className="timer-text">
                Resend code in: <span className="phone-number">{timer}s</span>
              </p>
            ) : (
              showResend && (
                <p className="resend-text">
                  Didn't get code?{" "}
                  <span className="resend-link" onClick={handleResend}>
                    Resend
                  </span>
                </p>
              )
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-outline-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-warning"
            onClick={handleVerify}
            disabled={isLoading || token.length < 6}
          >
            {isLoading ? "Verifying..." : "Verify"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default OtpVerfication;
